import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const ERROR_COMPONENT_COMMON_PROPS = {
    image: 'illustration_confirmation_error',
    dataTestId: 'error-component',
    variant: VARIANTS.EmptyStatusVariantType.DEFAULT,
  },
  ERROR_COMPONENT_BUTTON_PROPS = {
    dataTestId: 'error-component-button',
    type: 'primary',
  };

export { ERROR_COMPONENT_BUTTON_PROPS, ERROR_COMPONENT_COMMON_PROPS };
